import { createFileRoute } from '@tanstack/react-router';
import { endOfMonth, startOfMonth } from 'date-fns';
import { useState } from 'react';
import AuthGuard from '@/components/auth-guard';
import { DashboardOverview } from '@/components/dashboard/dashboard-overview';
import type { PeriodSelection } from '@/components/dashboard/period-selector';
import { PeriodSelector } from '@/components/dashboard/period-selector';

export const Route = createFileRoute('/dashboard')({
  component: RouteComponent,
});

function RouteComponent() {
  const today = new Date();
  const [selectedPeriod, setSelectedPeriod] = useState<PeriodSelection>({
    type: 'current',
    startDate: startOfMonth(today),
    endDate: endOfMonth(today),
    label: 'Mês atual',
  });


  return (
    <AuthGuard requireAuth={true}>
      <div className="container mx-auto space-y-6 px-4 py-6">
        {/* Header with Period Selector */}
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <h1 className="font-bold text-3xl tracking-tight">Visão Geral</h1>
          </div>
          <div className="flex-1">
            <PeriodSelector
              onPeriodChange={setSelectedPeriod}
              selectedPeriod={selectedPeriod}
            />
          </div>
        </div>

        {/* Dashboard Overview */}
        <DashboardOverview selectedPeriod={selectedPeriod} />

      </div>
    </AuthGuard>
  );
}
